// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2201":"52e8a12a","4731":"8a7326ad","6040":"8a7326ad"}[chunkId] + ".chunk.css";
};